























































import { Component } from "vue-property-decorator";
import { ErrosService, Lista } from "@/services/erros.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateTimeSeconds } from "@/shared/filters";
import GlobalMixin, { StateMenu } from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import Confirm from "@/shared/components/confirm.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";

@Component({
  components: { DataTable, Tooltip, DatePicker, Confirm },
  filters: { dateTimeSeconds },
})
export default class Erros extends mixins(GlobalMixin) {
  filtro: Lista = {
    txtPesquisa: "",
    txtPeriodo: "",
    offset: 0,
    limit: 100,
    order: "",
  };

  promise: Promise<any> | null = null;

  headers = [
    { value: "data", text: "Data", width: "165", withAliasValue: "err.Data" },
    { value: "descricao", text: "Descrição", class: "fonte", withAliasValue: "err.Descricao" },
    { value: "pagina", text: "Página", class: "fonte", withAliasValue: "err.Pagina" },
    { value: "consultor.idConsultor", text: "Id. Consultor", withAliasValue: "con.idConsultor" },
    { value: "consultor.nome", text: "Nome Consultor", withAliasValue: "con.Nome" },
    { value: "actions", text: "Ação", sortable: false },
  ];

  mounted() {
    this.setMenuState(StateMenu.fechado);
    this.filtro.txtPesquisa = "";
  }

  fetchErros(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = ErrosService.Listar(this.filtro);
  }

  detalhes(item: any) {
    if (item) {
      this.$router.push({
        name: "detalhes-erro",
        params: { idErro: item.idErro },
      });
    }
  }

  async limparTodosErros() {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Apagar Erros`;
    const text = `Deseja apagar todos os erros?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await ErrosService.Limpar().finally(this.stopLoader);
      this.fetchErros();
    }
  }
}
